
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]",
      function () {
        return require("private-next-pages/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]"])
      });
    }
  